module.exports = __webpack_public_path__ + "img/iconfinder_Rounded_Instagram_svg_5282544.478f0fda.svg";